import { TkvAction, TkvActions } from '../tkvActions';
import { AntragsummerGenerated } from '../actiontypes/antragsummerGenerated';

export const antragsnummerReducer = function (
  sectionState: string = null,
  action: TkvAction<AntragsummerGenerated>,
): string {
  switch (action.type) {
    case TkvActions.ANTRAGSNUMMER_GENERATED: {
      return action.payload.antragsnummer;
    }
    default:
      return sectionState;
  }
};
